import { Component, Input } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-disable-poor-outstanding',
  templateUrl: './disable-poor-outstanding.component.html',
  styleUrls: ['./disable-poor-outstanding.component.css'],
})
export class DisablePoorOutstandingComponent {
  @Input() question!: Question;
}
